import classnames from 'classnames'
import React, { useLayoutEffect, useRef, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import './ReadMore.scss'

interface ReadMoreProps {
  children: React.ReactNode
  lines?: number
}

const ReadMore = ({ children, lines = 3 }: ReadMoreProps) => {
  const [expanded, setExpanded] = useState(false)
  const [isTruncated, setIsTruncated] = useState(false)

  const ref = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const el = ref.current
    if (!el || expanded) return undefined

    const checkTruncation = () =>
      setIsTruncated(el.scrollHeight > el.clientHeight)
    checkTruncation()

    const observer = new ResizeObserver(checkTruncation)
    observer.observe(el)
    return () => observer.disconnect()
  }, [expanded, lines])

  return (
    <div
      className="read-more"
      style={{ '--line-clamp': lines } as React.CSSProperties}
    >
      <div
        ref={ref}
        className={classnames('read-more-body', {
          'read-more-body-expanded': expanded,
        })}
      >
        {children}
      </div>
      {(isTruncated || expanded) && (
        <button
          type="button"
          className="read-more-trigger"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? (
            <FormattedMessage defaultMessage="Show less" />
          ) : (
            <FormattedMessage defaultMessage="Read more" />
          )}
        </button>
      )}
    </div>
  )
}

export { ReadMore }
